// 账号 $accountId 布局：仅渲染 Outlet。
// 详情页位于同目录的 $accountId.index.tsx；
// 子路由 $accountId.modules.$module.edit.tsx 通过这里挂载 Outlet 渲染。

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/accounts/$accountId")({
  component: AccountLayout,
});

function AccountLayout() {
  return <Outlet />;
}
